





















import { IJobPosting } from '@app/componentlib/common/types/JobSearchTypes';
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch';
import { AppModule } from '@app/componentlib/src/store/modules/app';
import Vue from 'vue'
import Component from 'vue-class-component'
import JobViewContainer from '@app/componentlib/src/views/components/job-components/JobViewContainer.vue'
import { IResultPage } from '@app/componentlib/common/types/JobMatchTypes';
import MobileButtonBottom from '@app/componentLib/src/views/components/shared/MobileButtonBottom.vue'

@Component<DeepLinkResult>({
  props: {
    content: Object
  },
  components: {
    JobViewContainer,
    MobileButtonBottom
  }
})

export default class DeepLinkResult extends Vue {
  /**
   * Props variables
   */
  content: IResultPage | undefined

  /**
   * Component state variables
   */

  /**
   * Lifecycle
   */
  async mounted() {
    JobMatchModule.getAdvert(this.deepLinkJobId)
  }

  /**
   * Getters
   */
  get deepLinkJobId(): number {
    return JobMatchModule.deepLinkJobId
  }

  //deepLinkAdvert gets converted into a list, because JobViewContainer takes a list of adverts
  get deepLinkAdvert(): IJobPosting[] | undefined {
    var advertArray: IJobPosting[] = []
    if (JobMatchModule.advert !== undefined) {
      JobMatchModule.setSelectedJobPosting(JobMatchModule.advert)
      advertArray.push(JobMatchModule.advert)
    }

    return advertArray
  }

  get isMobile(): boolean {
    return AppModule.isMobile
  }

  get selectedJobPosting(): IJobPosting | undefined {
    return JobMatchModule.selectedJobPosting
  }

  /**
   * Methods
   */

   async setSelectedJobPosting(posting: IJobPosting) {
    JobMatchModule.setSelectedJobPosting(posting)
  }

}
